<template>
    <div>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            ref="multipleTable"
            class="table_content mini_div"
            border
            style="width: 100%;">
            <el-table-column
                label="分析文件名"
                min-width="150"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.record_name }}</div>
                </template>
            </el-table-column>
            <!-- <el-table-column
                label="上传的文件名"
                width="150"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.filename }}</div>
                </template>
            </el-table-column> -->
            <el-table-column
                label="状态"
                width="100"
                align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.task_tag == 1" type="success">完成</el-tag>
                    <el-tag v-else-if="scope.row.task_tag == 0" type="info">进行中</el-tag>
                    <el-tag v-else-if="scope.row.task_tag == -1" type="danger">失败</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                label="上传时间"
                sortable="custom"
                prop="add_time"
                width="144"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.start_time }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                width="100">
                <template slot-scope="scope">
                    <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click="download_file(scope.row)" :disabled="disabled">下载文件</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="float: right;margin-top: 10px; padding-bottom: 30px"
            layout="total, sizes, prev, pager, next">
        </el-pagination> -->
    </div>
</template>

<script>
import * as api from "@/api/statistics/statistics";
import { binary_download } from "@/utils/method";
export default {
    props: {
        task_type: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            list: [],
            disabled: false,
            loading: false
        };
    },
    methods: {
        getList() {
            this.loading = true;
            api.listing_tasking_detail({
                asin: this.$route.query.asin,
                task_type: this.task_type
            })
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.detail_list;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        //下载文件
        download_file(data) {
            if (data.task_tag == 0) {
                return this.$message({
                    type: "error",
                    message: "正在进行分析，不可下载！"
                });
            } else if (data.task_tag == -1) {
                return this.$message({
                    type: "error",
                    message: "正在分析失败，不可下载！"
                });
            } else {
                binary_download(
                    "/apis/v1/common_file_export_by_path",
                    "post",
                    {},
                    {
                        file_path: data.download_file_path
                    },
                    "application/vnd.ms-excel",
                    data.record_name
                );
            }
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
.mini_div .el-button--mini {
    padding: 5px 5px !important;
}
/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
